/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { JSXElement, Component, createSignal, createEffect } from 'solid-js';

export interface SwitchButtonProps {
  name: string;
  onChange?(checked: boolean): void;
  id?: string;
  isChecked?: boolean;
  label?: string;
  disabled?: boolean;
}

const SwitchButton: Component<SwitchButtonProps> = (props): JSXElement => {
  let switchRef: HTMLDivElement | undefined;
  const [checked, setChecked] = createSignal<boolean>(false);

  // Reactive getters for props
  const getName = () => props.name || '';
  const getId = () => props.id || `${getName()}-switch`;
  const getIsChecked = () => props.isChecked ?? false;
  const getLabel = () => props.label || '';
  const getDisabled = () => props.disabled ?? false;

  // Sync with isChecked prop
  createEffect(() => {
    setChecked(getIsChecked());
  });

  const getClassNames = (
    base: string,
    conditional: Record<string, boolean> = {}
  ) => {
    const classes = [base];
    Object.entries(conditional).forEach(([key, value]) => {
      if (value) classes.push(key);
    });
    return classes.join(' ');
  };

  const handleCheck = () => {
    if (getDisabled()) {
      return;
    }

    const newChecked = !checked();
    setChecked(newChecked);

    // Call onChange if provided
    if (props.onChange) {
      props.onChange(newChecked);
    }
  };

  return (
    <div ref={switchRef} class="switch-group switch-left">
      {getLabel() && (
        <label class="switch-label" for={getId()}>
          {getLabel()}
        </label>
      )}
      <div class={getClassNames('switch', { disabled: getDisabled() })}>
        <input
          class="switch-input"
          onChange={handleCheck}
          name={getName()}
          id={getId()}
          type="checkbox"
          checked={checked()}
          disabled={getDisabled()}
        />
        <label
          class="switch-paddle"
          for={getId()}
          style={getDisabled() ? { cursor: 'not-allowed' } : {}}
        >
          &nbsp;
        </label>
      </div>
    </div>
  );
};

export default SwitchButton;
